import { TEMPLATE } from 'app/security/core/services/template';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Authentication } from './../models/authentication';
import { RestApi } from 'app/auth/rest.api';

@Injectable()
export class AuthenticationService {
  authenticationUrl = 'api/Authentication'; // api/Authentication
  private _maintenanceWindowUrl =
    'api/Maintenance/GetStateMaintenanceWindow';
  constructor(private _restApi: RestApi) { }

  getAuthenticationData(): Observable<Authentication> {
    return this._restApi.get(`${this.authenticationUrl}`);
  }

  getMultipleOptions(): Observable<Array<any>> {
    return this._restApi.get(`${this.authenticationUrl}/Multiple/Options`);
  }

  getAuthenticationIsValid(): Observable<boolean> {
    return this._restApi.get(`${this.authenticationUrl}/IsValid`);
  }

  getMultipleOptionsDefaultValues(): Observable<any> {
    return this._restApi.get(`${this.authenticationUrl}/Default`);
  }

  getTemplateAuthentication(): Observable<{ [key: string]: any }> {
    return Observable.of(TEMPLATE);
  }

  putAuthentication(body: any): Observable<any> {
    return this._restApi.put(`${this.authenticationUrl}`, body);
  }

  getAuthenticationMetadata() {
    return this._restApi
      .get(`${this.authenticationUrl}/AuthenticationDetails`)
      .toPromise();
  }

  isAvailableForChanges(): Promise<boolean> {
    return this._restApi
      .get(this._maintenanceWindowUrl)
      .map((data: any) => {
        if (data.State === 'InProgess' && data.Mode === 'Manual') {
          return true;
        }
        return false;
      })
      .toPromise();
  }
}
